import React from "react";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from 'uuid';
import { toNString } from "../../../helpers/guids";
import { getDocumentTypeFromMime } from "../../utilities/DocumentTypeIcon";
import { DropzoneOptions, FileRejection, useDropzone } from "react-dropzone";
import { Control, Controller, UseFieldArrayReturn, UseFormSetValue } from "react-hook-form";

export const DropzoneBaseOptions: DropzoneOptions = {
    maxFiles: 5,
    accept: {
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "text/csv": [],
        "image/gif": [],
        "image/jpeg": [],
        "image/png": [],
        "application/pdf": [],
        "application/vnd.ms-excel": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/xml": [],
        "text/plain": [],
        "video/mp4": [],
        "video/mpeg": [],
        "video/x-msvideo": [],
        "application/vnd.ms-outlook": [],
        "message/rfc822": []
    }
};

export type MailMessageUploadProps = MailMessage;
export type MailMessageUploadFormProps = UseFieldArrayReturn<MailMessageUploadProps, 'attachments', 'id'> & {
    control: Control<MailMessageUploadProps, any>,
    setValue: UseFormSetValue<MailMessageUploadProps>
};

export const MailMessageAttachmentsUploadForm = ({ control, append } : MailMessageUploadFormProps) => {
    const onDrop = React.useCallback((acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
        // notify the user of any failed files
        for (let i = 0; i < rejectedFiles.length; i++) {
            toast.error(`Could not attach file '${rejectedFiles[i].file.name}'. Reason: ${rejectedFiles[i].errors[0]}`);
        }
        // append all the files that our dropzone params have said that the file is acceptable to be uploaded
        append(acceptedFiles.map((el: File) => ({
            id: toNString(uuidv4()),
            file: el,
            documentId: null,
            type: 'Upload',
            name: el.name,
            size: el.size,
            fileType: getDocumentTypeFromMime(el.type),
            lastModified: el.lastModified,
            password: null
        } as MailMessageAttachment)))
    }, []);

    const { getRootProps, getInputProps } = useDropzone({ ...DropzoneBaseOptions, onDrop });
    return (
        <Controller
            name="attachments"
            control={control}
            rules={{ required: false }}
            render={({ field: { ref, value, onChange, onBlur, ...rest } }) => (
                <div {...getRootProps({ className: 'dropzone d-flex mb-2 border border-3 border-opacity-10' })}>
                    <input {...getInputProps()} multiple />
                    <div className="d-flex flex-fill justify-content-center align-items-center py-1">
                        <p className="m-0">Drag and drop attachments here or click to browse for files.</p>
                    </div>
                </div>
            )}
        />
    );
};